import { memo } from 'react';
import { Box, useTheme } from '@mui/material';
import { StatusBlinker } from './StatusBlinker';
import { STATUS_COLORS } from '@/shared/constants';

function resolveStatusColor(
  raw?: string | null,
  colorMap?: Record<string, string>
): string {
  const map = colorMap ?? STATUS_COLORS;
  const v = (raw ?? '').toUpperCase();
  if (map[v]) return map[v];
  // Fallback for compound states like 'L1 APPROVED', 'L2 REJECTED'
  const entry = Object.entries(map).find(([key]) => v.includes(key));
  return entry?.[1] ?? '#9E9E9E';
}

export const StatusPill = memo(function StatusPill({
  value,
  active,
  hideBlinker = false,
  colorMap,
}: {
  value?: string;
  active?: boolean;
  hideBlinker?: boolean;
  colorMap?: Record<string, string>;
}) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {!hideBlinker && <StatusBlinker active={active} />}
      <Box
        sx={{
          backgroundColor: resolveStatusColor(value, colorMap),
          color: '#fff',
          px: 1.5,
          pt: 0.3,
          pb: 0.2,
          mb: 0.2,
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: 500,
          display: 'inline-block',
          minWidth: '60px',
          textAlign: 'center',
          textTransform: 'capitalize',
          border: `1px solid ${theme.palette.divider}`,
        }}
      >
        {value}
      </Box>
    </Box>
  );
});
